import AccountingEntryGroupList from "../components/accounting-entries-groups/AccountingEntriesGroupCrud";

const AccountingEntriesGroupPage = () => {
  return (
    <>
      <AccountingEntryGroupList />
    </>
  );
};

export default AccountingEntriesGroupPage;
